// extracted by css-extract-rspack-plugin
export default {"root":"root-V7AdLY","prose":"prose-PDAr9W text-body-md"};